module.exports = __webpack_public_path__ + "img/de_de.b75b431d.png";